import React from 'react'
import { trackEvent } from '../../../utils/analytics'
import { useOutletContext } from 'react-router-dom'

interface TabSelectorProps {
  activeTab: string
  onTabChange: (tab: string) => void
}

const TabSelector: React.FC<TabSelectorProps> = ({ activeTab, onTabChange }) => {
  const { campaign } = useOutletContext() as { campaign: any }

  const tabs = [
    { key: 'overview', label: 'Performance Overview' },
    { key: 'analytics', label: 'Analytics Dashboard' },
    { key: 'websites', label: 'Website Performance' }
  ]

  const handleTabChange = (tabKey: string) => {
    onTabChange(tabKey)
    trackEvent('report_tab_changed', {
      campaignId: campaign?._id,
      previousTab: activeTab,
      newTab: tabKey,
    })
  }

  return (
    <div className="flex items-center bg-gray-100 rounded-lg p-1">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => handleTabChange(tab.key)}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 ${
            activeTab === tab.key
              ? 'bg-white text-blue-600 shadow-sm border border-gray-200'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}

export default TabSelector